import React from 'react';

import { TypographyStyled } from './Typography.styled.ts';
import type { TypographyProps } from './Typography.types.ts';

const Typography: React.FC<TypographyProps> = ({
  component: Component = 'div',
  type,
  size = 'medium',
  style = 'normal',
  color,
  className,
  ...rest
}) => {
  return (
    <TypographyStyled
      as={Component}
      $type={type}
      $size={size}
      $style={style}
      color={color}
      className={className}
      {...rest}
    />
  );
};

export default Typography;
